import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { showError } from "src/app/shared/utils/functions/notification.function";

import { CognitoService } from "./../../../shared/services/cognito.service";
import { ModalResetPasswordTokenComponent } from "../../components/modal-reset-password-token/modal-reset-password-token.component";

@Component({
  selector: "app-lost-password",
  templateUrl: "./lost-password.component.html",
  styleUrls: ["./lost-password.component.scss"],
})
export class LostPasswordComponent {
  formForgotPassword: FormGroup;

  modalRef: MDBModalRef;

  constructor(
    private modalService: MDBModalService,
    private cognitoService: CognitoService
  ) {
    this.createForms();
  }

  send() {
    if (this.formForgotPassword.invalid) {
      return showError("", "O campo 'Email' não podem ser vazio.");
    }

    this.resetPassword();
  }

  //FORMS
  private createForms() {
    this.formForgotPassword = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.email]),
    });
  }

  //PRIVATES
  private resetPassword() {
    this.cognitoService.resetPassword(this.email.value).subscribe(
      (res) => {
        this.modalRef = this.modalService.show(
          ModalResetPasswordTokenComponent,
          {
            ignoreBackdropClick: true,
            scroll: true,
            data: { username: this.email.value, email: this.email.value },
          }
        );
      },
      (e) => {
        showError("", e.message);
      }
    );
  }

  //GET & SETTER
  private get email() {
    return this.formForgotPassword.get("email");
  }
}
